
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {
  LayoutDashboard,
  Building,
  Users,
  Database,
  FileText,
  Settings,
  MessageSquare,
  BookOpen,
  CreditCard,
  UserCircle,
  Tag
} from 'lucide-react';

const SuperAdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { title: "Dashboard", url: "/super-admin/dashboard", icon: LayoutDashboard },
    { title: "Instances", url: "/super-admin/instances", icon: Building },
    { title: "Business Setup", url: "/super-admin/business-setup", icon: FileText },
    { title: "Subscriptions", url: "/super-admin/subscriptions", icon: Users },
    { title: "Pending Orders", url: "/super-admin/pending-orders", icon: CreditCard },
    { title: "Reward Sales", url: "/super-admin/reward-sales", icon: Tag },
  ];

  const secondaryMenuItems = [
    { title: "Referral Bank", url: "/super-admin/referral-bank", icon: Database },
    { title: "Support", url: "/super-admin/support", icon: MessageSquare },
    { title: "Knowledge Base", url: "/super-admin/knowledge-base", icon: BookOpen },
    { title: "Settings", url: "/super-admin/settings", icon: Settings },
    { title: "Profile", url: "/super-admin/profile", icon: UserCircle },
  ];

  return (
    <Sidebar className="border-r">
      <SidebarContent>
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Super Admin Portal</h2>
        </div>
        
        <SidebarGroup>
          <SidebarGroupLabel>Main Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.url)}
                    isActive={location.pathname === item.url}
                    className="w-full"
                  >
                    <item.icon className="h-5 w-5 mr-3" />
                    {item.title}
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupLabel>Management</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {secondaryMenuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.url)}
                    isActive={location.pathname === item.url}
                    className="w-full"
                  >
                    <item.icon className="h-5 w-5 mr-3" />
                    {item.title}
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default SuperAdminSidebar;
